import * as React from "react";

import {
  createDataSourceIntersectionContext,
  GenericDataSourceIntersectionProvider,
} from "../../../Common";

import { MyBagTotals_Response } from "../../model";

import { useDataSourceMyBagTotalsQuery } from "../data-source--mybag-totals-provider";
import { useDataMutableSourceSuccessClientStorageData_MyBagTotals_GenericIntersectable } from "../data-mutable-source-success-client-storage-data";

type ThisDataConsumerInterface = MyBagTotals_Response;

export const MyBagTotalsDataSourceIntersectionProvider: React.FunctionComponent =
  (props) => {
    const dataSourceMyBagTotalsQuery = useDataSourceMyBagTotalsQuery();
    const dataMutableSourceSuccessClientStorageData =
      useDataMutableSourceSuccessClientStorageData_MyBagTotals_GenericIntersectable();

    const dataSources = React.useMemo(
      () => [
        dataSourceMyBagTotalsQuery,
        dataMutableSourceSuccessClientStorageData,
      ],
      [dataSourceMyBagTotalsQuery, dataMutableSourceSuccessClientStorageData]
    );

    return (
      <GenericDataSourceIntersectionProvider<ThisDataConsumerInterface>
        context={MyBagDataTotalsDataSourceIntersectionContext}
        dataSources={dataSources}
      >
        {props.children || []}
      </GenericDataSourceIntersectionProvider>
    );
  };

export const [
  MyBagDataTotalsDataSourceIntersectionContext,
  useMyBagTotalsDataSourceIntersection,
] = createDataSourceIntersectionContext<ThisDataConsumerInterface>();
